import React from "react";
import { ManageSourcesContainer } from "../../../containers";

const ManageSources = (props) => {
  return <ManageSourcesContainer {...props} />;
};

export default ManageSources;
